import { RoleAccesibility } from '../../Models/Maintenance/Accessibilities/Roles';
import { Authentication } from "../../Models/Authentication/Authentication";

import LocalStorageHelper from './LocalStorageHelper';

import { RoleAccesibilityField } from '../Enums/ParametersEnum';
import { AdminModules } from '../Enums/AdminModulesEnum';
import { AuthenticationField } from "../Enums/ParametersEnum";
import { RouteEnum } from "../Enums/RouteEnums";
import { ViewType } from '../Enums/ViewTypeEnum';

import { ErrorMessage } from "../../Constants/Messages";

const AccessibilityHelper = {
    mapRoleAccessibilities: async function (accesibilities: any, roleAccessibilities: RoleAccesibility[]) {
        let _roleAccessibilities: RoleAccesibility[] = [];

        if(accesibilities?.length > 0) {
            for (const [key, item] of Object.entries(accesibilities)) {
                let roleAccessibility = roleAccessibilities?.find((raItem: RoleAccesibility) => raItem?.[RoleAccesibilityField.ACCESSIBILITY_ID] == accesibilities[key]?.id);

                _roleAccessibilities.push({
                    [RoleAccesibilityField.ACCESSIBILITY_ID]: accesibilities[key]?.id ?? 0,
                    [RoleAccesibilityField.IS_PERMITTED]: roleAccessibility?.[RoleAccesibilityField.IS_PERMITTED] ?? false,
                });

                if(accesibilities[key]?.subItems?.length > 0) {
                    let _mapSubRoleAccessibilities = await this.mapRoleAccessibilities(accesibilities[key]?.subItems ?? [], roleAccessibilities);

                    if(_mapSubRoleAccessibilities.length > 0) {
                        _mapSubRoleAccessibilities?.forEach((subItem: any, subIndex: number) => {
                            _roleAccessibilities.push(subItem);
                        });
                    }
                }
            }
        }

        return _roleAccessibilities;
    },
    // hasAccess: function (accessEnum: AdminModules, enqueueSnackbar: any = null) {
    hasAccess: function (accessEnum: AdminModules, vType: any = null) {
        let userData: Authentication = LocalStorageHelper.getUserData();

        var accessModules = userData?.[AuthenticationField.ACCESSIBILITIES] ?? [];
        var hasAccess = false;
        
        if (accessModules?.length > 0) {
            hasAccess = accessModules?.find((x: AdminModules) => x == accessEnum) ? true : false;
            // if (hasAccess == accessEnum && accessEnum == DashboardAccessEnum.DASHBOARD){
            //     hasAccess = true;
            // }
        }

        // if (!hasAccess && enqueueSnackbar) {
        //     enqueueSnackbar(ErrorMessage.NO_PERMISSON, { variant: 'error' });
        // }

        return Boolean(hasAccess);
    },
    validatePath: function (pageId: any = null, routePath: any = null, vType: any = null) {
        let _isPathValid = false;
        let _validateViewType = this.validateViewType(pageId, routePath, vType);

        switch(routePath) {
            case RouteEnum.DASHBOARD:
                _isPathValid = this.hasAccess(AdminModules.DASHBOARD_VIEW);
            break;

            case RouteEnum.ADMIN_USER_CONTROL:
                _isPathValid = this.hasAccess(AdminModules.ADMIN_USER_VIEW);
            break;

            case RouteEnum.ADMIN_USER_DETAILS:
                _isPathValid = this.hasAccess(vType == ViewType.PREVIEW ? AdminModules.ADMIN_USER_VIEW : (vType == ViewType.EDIT ? AdminModules.ADMIN_USER_EDIT : AdminModules.ADMIN_USER_CREATE));
            break;

            case RouteEnum.COMPANIES:
                _isPathValid = this.hasAccess(AdminModules.COMPANY_VIEW);
            break;

            case RouteEnum.COMPANY_DETAILS:
                _isPathValid = this.hasAccess(vType == ViewType.PREVIEW ? AdminModules.COMPANY_VIEW : (vType == ViewType.EDIT ? AdminModules.COMPANY_EDIT : AdminModules.COMPANY_CREATE));
            break;

            case RouteEnum.LICENSES:
                _isPathValid = this.hasAccess(AdminModules.LICENSE_VIEW);
            break;

            case RouteEnum.BUY_LICENSE:
                _isPathValid = this.hasAccess(AdminModules.BUY_LICENSE);
            break;

            case RouteEnum.GENERATE_LICENSE:
                _isPathValid = this.hasAccess(AdminModules.GENERATE_LICENSE);
            break;

            case RouteEnum.LICENSE_DETAILS:
                _isPathValid = this.hasAccess(AdminModules.LICENSE_VIEW);
            break;

            case RouteEnum.BILLINGS:
                _isPathValid = this.hasAccess(AdminModules.BILLING_VIEW);
            break;

            case RouteEnum.BILLING_DETAILS:
                _isPathValid = this.hasAccess(vType == ViewType.PREVIEW ? AdminModules.BILLING_VIEW : (vType == ViewType.EDIT ? AdminModules.BILLING_EDIT : AdminModules.BILLING_CREATE));
            break;

            case RouteEnum.ACCESSIBILITIES:
                _isPathValid = this.hasAccess(AdminModules.ACCESSIBILITIES_VIEW);
            break;

            case RouteEnum.ACCESSIBILITY_DETAILS:
                _isPathValid = this.hasAccess(AdminModules.ACCESSIBILITIES_VIEW);
            break;

            case RouteEnum.MODULE_SETTING:
                _isPathValid = this.hasAccess(AdminModules.MODULE_SETTINGS_VIEW);
            break;

            case RouteEnum.PRICE_SETTING:
                _isPathValid = this.hasAccess(AdminModules.PRICE_SETTINGS_VIEW);
            break;
            case RouteEnum.VENDORS:
                _isPathValid = this.hasAccess(AdminModules.VENDORS_VIEW);
            break;
            case RouteEnum.REGISTRATION_CODES:
                _isPathValid = this.hasAccess(AdminModules.REGISTRATION_CODES_VIEW);
            break;

            case RouteEnum.MY_PROFILE:
                _isPathValid = (vType != ViewType.ADD ? this.hasAccess(vType == ViewType.PREVIEW ? AdminModules.MY_PROFILE_VIEW : AdminModules.MY_PROFILE_EDIT) : false);
            break;
        }

        if(_isPathValid) {
            _isPathValid = this.isValidPageId(pageId, routePath);
        }

        return _isPathValid;
    },
    isValidPageId: function (pageId: any = null, routePath: any = null) {
        let uData: Authentication = LocalStorageHelper.getUserData();
        let isValidatePageId = false;

        if(routePath == RouteEnum.ADMIN_USER_DETAILS ||
        routePath == RouteEnum.COMPANY_DETAILS ||
        routePath == RouteEnum.LICENSE_DETAILS ||
        routePath == RouteEnum.BILLING_DETAILS ||
        routePath == RouteEnum.ACCESSIBILITY_DETAILS ||
        routePath == RouteEnum.MY_PROFILE) {
            isValidatePageId = pageId != null && pageId != "";
            isValidatePageId = (routePath == RouteEnum.MY_PROFILE ? (pageId == uData?.[AuthenticationField.PUBLIC_ID]) : isValidatePageId);
        } else {
            isValidatePageId = true;
        }

        return isValidatePageId;
    },
    validateViewType: function (pageId: any = null, routePath: any = null, viewType: ViewType = ViewType.ADD) {
        let _viewTypeValid = true;
        let _proceedValidation = false;
        let _moduleViewAccessId = 0;
        let _moduleAddAccessId = 0;
        let _moduleEditAccessId = 0;

        switch(routePath) {
            case RouteEnum.ADMIN_USER_DETAILS:
                _proceedValidation = true;

                _moduleViewAccessId = AdminModules.ADMIN_USER_VIEW;
                _moduleAddAccessId = AdminModules.ADMIN_USER_CREATE;
                _moduleEditAccessId = AdminModules.ADMIN_USER_EDIT;
            break;

            case RouteEnum.COMPANY_DETAILS:
                _proceedValidation = true;

                _moduleViewAccessId = AdminModules.COMPANY_VIEW;
                _moduleAddAccessId = AdminModules.COMPANY_CREATE;
                _moduleEditAccessId = AdminModules.COMPANY_EDIT;
            break;

            case RouteEnum.BILLING_DETAILS:
                _proceedValidation = true;

                _moduleViewAccessId = AdminModules.BILLING_VIEW;
                _moduleAddAccessId = AdminModules.BILLING_CREATE;
                _moduleEditAccessId = AdminModules.BILLING_EDIT;
            break;

            case RouteEnum.MY_PROFILE:
                _proceedValidation = true;

                _moduleViewAccessId = AdminModules.MY_PROFILE_VIEW;
                _moduleAddAccessId = 0;
                _moduleEditAccessId = AdminModules.MY_PROFILE_EDIT;
            break;
        }

        if(_proceedValidation) {
            let _proceed: boolean = false;
            let _vType: ViewType = ViewType.ADD;
            let _hasAcceess = false;

            if(pageId != '0' && pageId != '' && pageId != null) {
                if(viewType == ViewType.ADD) {
                    _proceed = true;
                    _vType = ViewType.EDIT;
                    _hasAcceess = this.hasAccess(_moduleEditAccessId);
                    if(!_hasAcceess) {
                        _vType = ViewType.PREVIEW;
                        _hasAcceess = this.hasAccess(_moduleViewAccessId);
                    }
                }

                if(viewType == ViewType.EDIT) {
                    _hasAcceess = this.hasAccess(_moduleEditAccessId);

                    if(!_hasAcceess) {
                        _proceed = true;
                        _vType = ViewType.PREVIEW;
                        _hasAcceess = this.hasAccess(_moduleViewAccessId);
                    }
                }
            } else {
                if(viewType != ViewType.ADD) {
                    _proceed = true;
                    _vType = ViewType.ADD;
                    _hasAcceess = this.hasAccess(_moduleAddAccessId);
                }
            }

            if(_proceed) {
                _viewTypeValid = false;
                
                if(_hasAcceess) {
                    window.location.replace(`${routePath}?id=${pageId}&view=${_vType}`);
                }
            }
        }

        return _viewTypeValid;
    },
};

export default AccessibilityHelper;